import React from 'react';
import { Input as MuiInput } from '@material-ui/core';

const Input = props => <MuiInput {...props} />;

export default Input;
